export enum BasketballTwoPointShotMadeAttribute {
  JumpShot = 651,
  Layup = 652,
  Dunk = 653,
  Hook = 654,
  PointsFromTurnovers = 724,
  PointsInThePaint = 725,
  SecondChancePoints = 726,
  FastBreakPoints = 727,
  And1 = 948,
  StepBack = 949,
  AlleyOop = 950,
  Driving = 951,
  Floating = 952,
  TipPutback = 953,
}
